module.exports = __webpack_public_path__ + "img/websiteDisplay.b3a92ca0.webp";